import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { QueryService } from '@ngneat/query';
import { environment } from 'src/environments/environment';
import { EcommercePriceList } from '../types/types';

export type EcommerceInstanceConfig = {
  id: string;
  priceLists: EcommercePriceList[];
  name: string;
  status: string;
  ecommerceUrl: string;
  facebookClientId?: string;
  facebookClientSecret?: string;
  googleClientId?: string;
  googleClientSecret?: string;
};

@Injectable({ providedIn: 'root' })
export class EcommerceService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _queryService = inject(QueryService);

  queryEcommerceInstance(ecommerceInstanceId: string) {
    return this._queryService.use(
      ['ecommerce-instance', ecommerceInstanceId],
      () => {
        return this._httpClient.get<EcommerceInstanceConfig>(
          `${environment.apiUrl}/public/e-commerce/structure/${ecommerceInstanceId}`
        );
      }
    );
  }
}
